import { ComponentStyleConfig, theme } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

export const Popover: ComponentStyleConfig = {
  defaultProps: {
    variant: 'rw1',
  },
  // We need to inject the parts this way below since it's coming from some
  // internal module we don't want to import.
  parts: theme.components.Popover.parts,
  variants: {
    rw1: (props: Dict) => ({
      body: {
        backgroundColor: mode(
          'rw1.body.light.clean',
          'rw1.secondary.dark.0',
        )(props),
        borderRadius: '1em',
        // Both dark and light themes uses the same shadow in Figma.
        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
      },
      content: {
        // Remove the ugly blue outline.
        _focus: {
          boxShadow: 'none',
          outline: 0,
        },
        border: 0,
        borderRadius: '1em',
        marginTop: '1em',
      },
    }),
  },
}
